import type {SelectedImageAsset} from '@Components/ai-chat-window/ai-chat-window.types';

export interface SelectedAssetThumbProps {
  asset: SelectedImageAsset;
}

export const SELECTED_ASSET_THUMB_SIZE_PX = 64;
